import getEnvFromLocation from 'utils/getEnvFromLocation'

const CUSTOMERIO_KEYS = {
  production: 'dcaac826b1d0275ecf8b',
  development: 'ef3fe309530bf1d6e1d0',
}

const appEnv = getEnvFromLocation()

export const CUSTOMERIO_WRITE_KEY =
  CUSTOMERIO_KEYS[appEnv as keyof typeof CUSTOMERIO_KEYS] || CUSTOMERIO_KEYS.development

export const CUSTOMERIO_EVENT_NAMES = {
  FIRST_LOGIN: 'first_login',
  SEARCH_MADE: 'search_made',
  INSIGHT_SAVED: 'insight_saved',
  INSIGHT_SHARED: 'insight_shared',
  CREATED_REPORT: 'created_report',
  CREATED_BRIEFING: 'created_briefing',
  CREATED_DASHBOARD: 'created_dashboard',
  FEATURE_USED: 'feature_used',
  ADD_NICHE_CONTEXT: 'add_niche_context',
  CLICK_NICHE: 'click_niche',
} as const
